document.addEventListener("DOMContentLoaded", async () => {
	const form = document.querySelector('.js-subscribe_newsletters_form');

	if (!form) return;

	const allTopicsInput = form.querySelector('.js-subscribe_newsletters_all_topics');
	const topicInputs = [...form.querySelectorAll('.js-subscribe_newsletters_checkboxes input[type="checkbox"][name="type[]"]')];

	if (allTopicsInput) {
		allTopicsInput.addEventListener('change', () => {
			topicInputs.forEach((input) => {
				input.checked = allTopicsInput.checked;
			});
		});
	}

	form.addEventListener('formdata', (e) => {
		const types = e.formData.getAll('type[]');
		if (types.length > 0) return;

		const generalTech = topicInputs.find((input) => input.value === 'General Tech');
		const defaultCheckbox = generalTech || topicInputs[0];
		if (defaultCheckbox) {
			e.formData.append('type[]', defaultCheckbox.value);
		}
	});
});
